export function isTeamChallenge(challenge) {
  return challenge.challenge_type.includes('team-challenge') ||
          challenge.challenge_type === 'jackpot' || isTeamStep(challenge)
}

export function isIndividualChallenge(challenge) {
  return isIndividualStep(challenge) ||
          challenge.challenge_type.includes('jackpot-') || // eg: jackpot-2-challenge
          challenge.challenge_type.includes('hwager')
}

function isIndividualStep(challenge) {
  return challenge.challenge_type === 'step-challenge-4' || challenge.challenge_type === 'step-challenge-3'
}

function isTeamStep(challenge) {
  return challenge.challenge_type === 'step-challenge-2' || challenge.challenge_type === 'step-challenge-3'
}
